/**
 * Access codes the web checks with `$can(code)`.
 *
 * The catalogue itself lives on the server (orrish-backend
 * admins/access/catalogue.py, served at `team/permission_catalogue/`) and the
 * permission editor renders from that. This file only holds what navigation
 * needs before any request: which code opens each tab and each settings
 * section, and the order landing tabs are tried in.
 */

// Drawer / route tab title (any case) -> the code that makes the tab visible.
export const TAB_VIEW_CODES = {
  DASHBOARD: "dashboard.view",
  TEAM: "team.view",
  DEALER: "dealer.view",
  "LOAN SCHEMA": "loan_schema.view",
  "DELETE REQUESTS": "deletion_requests.view",
  LEADS: "leads.view",
  LOS: "los.view",
  DISBURSEMENT: "disbursement.view",
  LMS: "lms.view",
  COLLECTION: "collection.view",
  NACH: "nach.view",
  ACCOUNTS: "accounts.view",
  PAYMENTS: "payments.view",
  REPORTS: "reports.view",
  SETTINGS: "settings.view",
  "NOTICE MANAGEMENT": "notices.view",
  "SESSION HISTORY": "session_history.view",
  NOTIFICATIONS: "notifications.view",
  "USER SESSIONS": "session_history.view",
};

export function tabViewCode(title) {
  return TAB_VIEW_CODES[String(title || "").toUpperCase()] || null;
}

// Settings sub-tab route name -> sub-tab key in `settings.<key>.view|edit`.
export const SETTINGS_ROUTE_SUBTABS = {
  "settings profile": "profile",
  "settings calling": "calling",
  "settings flags": "flags",
  "settings activity": "activity",
  "settings reloan": "reloan_rules",
  "settings noc charges": "noc_charges",
  "settings auto approval": "auto_approval",
  "settings disbursement accounts": "disbursement_accounts",
  "settings auto assignment": "auto_assignment",
  "settings partner offers": "partner_offers",
  "settings banners": "banners",
  "verifiaction parameters": "verification_parameters",
};

// Order the sign-in page and the route guard use to pick a landing tab.
export const LANDING_ROUTES = [
  // Each dashboard board has its own code; `dashboard` itself only redirects
  // to the funnel, so it cannot be a landing for someone without that board.
  { name: "dashboard-funnel", code: "dashboard.funnel.view" },
  { name: "dashboard-disbursement", code: "dashboard.disbursement.view" },
  { name: "dashboard-portfolio", code: "dashboard.books.view" },
  { name: "dashboard-collections", code: "dashboard.collections.view" },
  { name: "dashboard-old", code: "dashboard.old.view" },
  { name: "agent-los", code: "leads.view" },
  { name: "lead-list", code: "los.view" },
  { name: "account-list", code: "disbursement.view" },
  { name: "lms-List", code: "lms.view" },
  { name: "collection-list", code: "collection.view" },
  { name: "nach-list", code: "nach.view" },
  { name: "ledger-panel", code: "accounts.view" },
  { name: "payments-panel", code: "payments.view" },
  { name: "reports-panel", code: "reports.view" },
  { name: "notifications", code: "notifications.view" },
  { name: "team", code: "team.view" },
  { name: "dealer", code: "dealer.view" },
  { name: "loan-scheme", code: "loan_schema.view" },
  { name: "delete-requests", code: "deletion_requests.view" },
  { name: "settings", code: "settings.view" },
];
